import { useState, useCallback } from 'react';
import { p9209Api, F90N } from '../../../services/p9209Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master record */
  const resolveAllNames = useCallback(async (data: Partial<F90N>) => {
    const entries: [string, string, string][] = [
      ['employee', 'employee', data.f90n_11 || ''],
      ['department', 'department', data.f90n_21 || ''],
      ['position', 'position', data.f90n_22 || ''],
      // Page 2 approval names
      ['supervisor', 'employee', data.f90n_62 || ''],
      ['hrManager', 'employee', data.f90n_67 || ''],
      ['vicePresident', 'employee', data.f90n_72 || ''],
      ['president', 'employee', data.f90n_77 || ''],
      ['hrStaff', 'employee', data.f90n_57 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        p9209Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await p9209Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, setNames, resolveAllNames, resolveSingleName, clearNames };
}
